import { BarAndPieChart } from "../../Charts/BarAndPieChart/BarAndPieChart";
import { BlankState } from "../BotAnalyticsDashboard";
import { Spinner } from "@swivl-mono/ui";

interface CallToActionProps {
  callToActionData: any[];
  colors: string[];
}

export const CallToAction: React.FC<CallToActionProps> = ({ callToActionData }) => {
  let content: JSX.Element, total: string = "0";
  
  if (callToActionData === null || callToActionData === undefined) {
    content = (
      <div className="loadingContent">
        <Spinner />
      </div>
    );
  } else if (callToActionData.length === 0) {
    content = <div className="loadingContent">{BlankState()}</div>;
  } else {
    // Calculate total CTA interactions
    total = callToActionData.reduce((sum, item) => sum + item.value, 0).toLocaleString();
    
    content = (
      <div className="barAndPieWapper">
        <BarAndPieChart 
          data={callToActionData} 
          showTotals={true} 
          height={200} 
          width={580} 
        />
      </div>
    );
  }
  
  return (
    <div className="chartBox">
      <div className="chartHeader">
        <div className="chartHeaderTitle">
          <span>Call to Action</span>
        </div>
        <div className="spacer" />
        <div className="headerTotal">{total || "0"}</div>
      </div>
      <div className="chartContent">{content}</div>
    </div>
  );
};